<template>
  <v-stepper-content step="1">
    <v-content fluid grid-list-lg style="padding: 0;">
      <v-layout row wrap>
        <v-flex md6>
          <v-subheader class="pl-0">Clinic Location</v-subheader>
          <remote-select
            v-model="att.locId"
            label="Location"
            service="locations"
            :disabled="lock"
            :error-messages="errs.locId"
            @change="clearErr('locId')"
          />
        </v-flex><v-flex md6>
          <v-subheader class="pl-0">Unit</v-subheader>
          <remote-select
            v-model="att.unitId"
            label="Unit"
            service="units"
            :disabled="lock"
            :error-messages="errs.unitId"
            @change="clearErr('unitId')"
          />
        </v-flex><v-flex md6 v-if="perm !== 'student' || att.stat !== 'inprogress'">
          <v-subheader class="pl-0">Clinical Session Student</v-subheader>
          <remote-select
            v-model="att.studentId"
            label="Student"
            service="users"
            :filter="{
              perm: 'student',
              invisible: { $ne: true },
              $sort: { text: 1 },
            }"
            :disabled="lock || !!att._id"
            :error-messages="errs.studentId"
            @change="clearErr('studentId')"
          />
        </v-flex><v-flex md6>
          <v-subheader class="pl-0">Clinical Session Supervisor</v-subheader>
          <remote-select
            v-model="att.supervisorId"
            label="Supervisor"
            service="users"
            :filter="{
              perm: { $ne: 'student' },
              invisible: { $ne: true },
            }"
            :disabled="lock || ( perm === 'staff' && !id )"
            :error-messages="errs.supervisorId"
            @change="clearErr('supervisorId')"
          />
        </v-flex><v-flex xs12>
          <v-subheader class="pl-0">Expected Duration (minutes)</v-subheader>
          <v-slider
            v-model="att.duration"
            :min="5"
            :max="180"
            :step="5"
            thumb-label="always"
            :readonly="lock"
            :error-messages="errs.duration"
            @change="clearErr('duration')"
          />
        </v-flex><v-flex xs12>
          <v-subheader class="pl-0">Session Procedures</v-subheader>
          <v-radio-group v-model="proType" :mandatory="false">
            <v-radio value="other">
              <remote-select
                slot="label"
                v-model="pros"
                label="Clinical Procedures"
                service="procedures"
                :filter="{
                  nonProcedural: { $ne: true },
                }"
                multiple
                chips
                clearable
                deletable-chips
                :disabled="lock"
                :error-messages="errs.proIds"
                @change="
                  clearErr('proIds');
                  $nextTick(() => {att.proIds = pros; proType = 'other';});
                "
                class="text-capitalize"
              />
            </v-radio>
            <v-radio
              v-for="pro in proceduresFind({
                query: {
                  $sort: { name: 1 },
                  nonProcedural: true,
                  adminOnly: false,
                },
              }).data"
              :key="pro._id"
              :label="pro.name"
              :value="[pro._id]"
            />
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-content>
    <v-btn color="primary" @click="$emit('update:step', 2)" :disabled="!valid">Continue</v-btn>
    <v-btn
      v-if="id && !lock"
      color="secondary"
      @click="$emit('save')"
      :disabled="!valid || !changed"
      :loading="loading"
    >
      Save
    </v-btn>
  </v-stepper-content>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import uniq from 'lodash/uniq';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import attemptEq from '../attemptEq';
import RemoteSelect from '../../../../components/input/remote-select.vue';

export default {
  components: {
    RemoteSelect,
  },
  props: {
    attempt: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    errs: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    lock: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      att: { comments: {} },
      proType: this.attempt.procedures && this.attempt.procedures[0].nonProcedural
        ? this.attempt.proIds
        : 'other',
      pros: this.attempt.proIds,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('locations', { locationsFind: 'find' }),
    ...mapGetters('procedures', { proceduresFind: 'find' }),
    ...mapGetters('units', { unitsFind: 'find' }),
    ...mapGetters('users', { usersFind: 'find', usersGet: 'get' }),
    perm() { return this.user && this.user.perm; },
    id() { return this.att && this.att._id; },
    valid() {
      return this.att
        && this.att.supervisorId
        && this.att.locId
        && this.att.unitId
        && this.att.proIds && this.att.proIds.length
        && this.att.duration;
    },
    units() {
      return this.unitsFind({
        query: {
          $sort: { text: 1 },
          year: (new Date()).getFullYear(),
        },
      }).data.filter(
        unit => (new Date(unit.start)).getTime() <= Date.now()
          && (new Date(unit.finish)).getTime() >= Date.now(),
      );
    },
  },
  methods: {
    setAtt() {
      if (!this.att || this.att._id !== this.attempt._id) this.pros = [];
      if (!attemptEq(this.att, this.attempt)) {
        this.att = cloneDeep(this.attempt);
        this.proType = (
          this.attempt.procedures
          && this.attempt.procedures.length
          && this.attempt.procedures[0].nonProcedural
            ? this.attempt.proIds
            : 'other'
        );
        if (this.proType === 'other') this.pros = this.attempt.proIds;
      }
    },
    clearErr(i) {
      const errs = cloneDeep(this.errors);
      set(errs, i, '');
      this.$emit('update:errors', errs);
    },
    updatePros(v) {
      const pros = this.proceduresFind({ query: { _id: { $in: v || [] } } }).data;
      this.att.procedures = pros;
      if (!this.att.patient) {
        this.att.teeth = uniq(pros.reduce((a, p) => [...a, ...p.teeth], []));
      }
      this.att.nopro = !!pros.find(p => p.nonProcedural);
      this.att.patreq = !this.att.nopro || !!pros.find(p => p.patientInfo);
      if (this.att.nopro) this.att.stepIds = uniq(pros.reduce((a, p) => [...a, ...p.stepIds], []));
    },
  },
  mounted() { this.setAtt(); },
  watch: {
    attempt: {
      handler() { this.setAtt(); },
      deep: true,
    },
    att: {
      handler() {
        if (!attemptEq(this.att, this.attempt)) this.$emit('update:attempt', this.att);
      },
      deep: true,
    },
    valid() { this.$emit('update:valid', this.valid); },
    'att.proIds'(v) { // eslint-disable-line object-shorthand
      this.updatePros(v);
    },
    proType(v) {
      if (v !== 'other') this.att.proIds = v;
      else this.att.proIds = this.pros;
      this.updatePros(v);
    },
  },
};
</script>
